import { Col, Row, Text } from 'components';
import { isToday, isYesterday } from 'date-fns';
import { normalizeDate } from 'lib';
import { useSelector } from 'react-redux';

import { MessageChunk } from './';

const Messages = ({ data }) => {
  const user = useSelector((state) => state.user);

  function getDateText(date) {
    switch (true) {
      case isToday(date):
        return 'Today';
      case isYesterday(date):
        return 'Yesterday';
      default:
        return normalizeDate(date, 'Days');
    }
  }

  return (
    <Col reverse pad="0 16px" noFlex wid="calc(100% - 32px)">
      {data.map((x, i) => (
        <Col wid="100%" key={i} noFlex>
          <Row centerAll marg={`${i === data.length - 1 ? 16 : 42}px 0 0`}>
            <Row bg="#7f8c9e" pad="4px 12px" hasRadius="20px">
              <Text b2 med col="#fff">
                {getDateText(x.title)}
              </Text>
            </Row>
          </Row>

          <Col reverse wid="100%">
            {x.data.map((x, i) => (
              <MessageChunk key={i} item={x} user={user} />
            ))}
          </Col>
        </Col>
      ))}
    </Col>
  );
};

export default Messages;
